import React from 'react';
import { DownloadPage } from './pages/DownloadPage';
export function App() {
  return <DownloadPage data-id="element-0" />;
}